"use client";
import React,{useState} from 'react'
import { ProductProvider } from '../components/Productcontext'
import Producthomecontent from '../components/Producthomecontent'
import Footer from '../components/Footer'
import PreHeader from '../components/PreHeader';
import Header from '../components/Header';
import Menu from '../components/Menu';
import  Airterminaldetailscontent from '../components/Airterminaldetailscontent';
import InstallationBanner from '../components/InstallationBanner';
import ProductsubMenu from '../components/ProductsubMenu';
import LightningProductsSubMenu from '../components/LightningProductsSubMenu';

import airterm from '../images/airterminal/air_terminal_page_banner.jpg';
import airterm_360 from '../images/airterminal/air_terminal_page_banner_360.jpg';
import airterm_tab from '../images/airterminal/air_terminal_page_banner_tab.jpg';
import airterm2x from  '../images/airterminal/air_terminal_page_banner@2x.jpg';

// import ProducthomeBanner from '../components/ProducthomeBanner';
// import ban1x from '../images/producthome/product-home-banner.jpg';
// import ban2x from '../images/producthome/product-home-banner@2x.jpg';
const AirTerminalPage = () => {
  const [selectedItem, setSelectedItem] = useState(null);

  const handleItemClick = (item) => {
    setSelectedItem(item);
    //setIpageValue(item);
    //console.log("set new ipaf vale "+item);
    
  };
    return (
      <div>
           <ProductProvider>
          {/* <PreHeader/>
          <Header/>    
           <Menu/> */}
           <InstallationBanner page="installation" banalt="Ashlok Safe Earthing air terminal for efficient lightning dissipation in protection systems" ashlokAfter="" ban1x={airterm} ban2x={airterm2x} ban360={airterm_360} bantab={airterm_tab}/>
            <ProductsubMenu/>
            <LightningProductsSubMenu onImageClick={handleItemClick}/>
          <Airterminaldetailscontent/>
           
           <Footer/>
           </ProductProvider>
      </div>
    )
  }
  
  export default AirTerminalPage
 
